import { useState } from "react";
import "../pages/css/RedirectPage.css";

const TenantSelectModal = ({ tenantOptions, onSelect, onClose }) => {
  const [chosenId, setChosenId] = useState("");

  const handleConfirm = () => {
    const tenant = tenantOptions.find(t => t.id === chosenId);
    console.log("Confirm clicked, chosenId=", chosenId, "tenant=", tenant);
    if (tenant) {
      onSelect(tenant);
    } else {
      console.warn("No tenant matched that ID");
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-box">
        <h3 className="tenant-modal-title">Access your DAQUMA AI tenant</h3>


        <ul className="tenant-list" role="listbox" aria-label="Available tenants">
          {tenantOptions.map((tenant) => {
            const selected = chosenId === String(tenant.id);

            return (
              <li key={tenant.id} className="tenant-list-item">
                <button
                  type="button"
                  className={`tenant-option ${selected ? "is-selected" : ""}`}
                  onClick={() => setChosenId(String(tenant.id))}
                  aria-selected={selected}
                  role="option"
                >
                  <span className="tenant-name">{tenant.name}</span>
                  
                </button>
              </li>
            );
          })}
        </ul>


        <div className="modal-actions">
          <button onClick={handleConfirm} disabled={!chosenId}>
            Confirm
          </button>
          <button onClick={onClose}>
            Cancel
          </button>
        </div>

      </div>
    </div>
  );
};

export default TenantSelectModal;
